<div
  data-qa="app-three-dots-menu-icon"
  class="{{alignLeft ? 'flex flex-row items-center justify-start' : 'flex flex-row items-center justify-center'}} clickable icon-size-1p375 {{divStyle}} {{active}}"
  [class.disabled-icon]="disabled" [class.no-propagation]="disabled" [class.icon-background-hover]="hover">
  @if (!horizontal) {
    <svg width="25" height="25"
         viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0586 6.87781C14.0586 7.70623 13.387 8.37781 12.5586 8.37781C11.7302 8.37781 11.0586 7.70623 11.0586 6.87781C11.0586 6.04938 11.7302 5.37781 12.5586 5.37781C13.387 5.37781 14.0586 6.04938 14.0586 6.87781Z"
        fill="#263238" />
      <path
        d="M14.0586 12.8778C14.0586 13.7062 13.387 14.3778 12.5586 14.3778C11.7302 14.3778 11.0586 13.7062 11.0586 12.8778C11.0586 12.0494 11.7302 11.3778 12.5586 11.3778C13.387 11.3778 14.0586 12.0494 14.0586 12.8778Z"
        fill="#263238" />
      <path
        d="M12.5586 20.3778C13.387 20.3778 14.0586 19.7062 14.0586 18.8778C14.0586 18.0494 13.387 17.3778 12.5586 17.3778C11.7302 17.3778 11.0586 18.0494 11.0586 18.8778C11.0586 19.7062 11.7302 20.3778 12.5586 20.3778Z"
        fill="#263238" />
    </svg>
  }
  @if (horizontal) {
    <svg width="24" height="25"
      viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 14C17.1716 14 16.5 13.3284 16.5 12.5C16.5 11.6716 17.1716 11 18 11C18.8284 11 19.5 11.6716 19.5 12.5C19.5 13.3284 18.8284 14 18 14Z"
        fill="#263238" />
      <path
        d="M12 14C11.1716 14 10.5 13.3284 10.5 12.5C10.5 11.6716 11.1716 11 12 11C12.8284 11 13.5 11.6716 13.5 12.5C13.5 13.3284 12.8284 14 12 14Z"
        fill="#263238" />
      <path
        d="M4.5 12.5C4.5 13.3284 5.17157 14 6 14C6.82843 14 7.5 13.3284 7.5 12.5C7.5 11.6716 6.82843 11 6 11C5.17157 11 4.5 11.6716 4.5 12.5Z"
        fill="#263238" />
    </svg>
  }
</div>
